export const theme = {
  fontColors: {
    primary: "#FFFFFF",
    secondary: "#343434",
    tertiary: "rgb(194, 80, 80)",
    textAddress: "#5D5D5D",
  },
  backgroundColors: {
    primary: "#F9F9F9",
    secondary: "#FFFFFF",
    tertiary: "#363A43",
    button: "#750000",
  },
  fontFamily: {
    primary: "'Montserrat', sans-serif",
    secondary: "'Cabin', sans-serif",
    tertiary: "'Reem Kufi', sans-serif",
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
};
